import { durationToText } from "../../../../../../../../../helpers/common"

const TotalDurationCell = ({ totalDuration, duration }) => {
    if (!duration) return '-'

    return <p className="mb-0">{durationToText(duration)} - <span className="fw-semibold text-primary">{Math.round((duration / totalDuration) * 100)}%</span></p>
}

export default TotalDurationCell